import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {AccountPermissionsService} from 'app/services/account-permissions.service';
import {Router} from '@angular/router';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss']
})

export class HomeComponent implements OnInit {
    constructor(
        public authenticationService: AuthenticationService,
        public accountService: AccountPermissionsService,
        private router: Router
    ) {}

    ngOnInit(): void {
        if (!this.authenticationService.userIsResident)
            this.router.navigateByUrl('/dashboard');
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/home/home.component.ts